/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_CancelledInputs */

const en_auth_cancelled = /** @type {(inputs: Auth_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled.`)
};

const de_auth_cancelled = /** @type {(inputs: Auth_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgebrochen.`)
};

/**
* | output |
* | --- |
* | "Cancelled." |
*
* @param {Auth_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_cancelled = /** @type {((inputs?: Auth_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_cancelled(inputs)
	return en_auth_cancelled(inputs)
});